'use client'

import { SsgoiTransition } from '@ssgoi/react'
import { usePathname } from 'next/navigation'

// `template.tsx` re-mounts on every navigation, so SsgoiTransition's
// lifecycle hooks fire and ssgoi can snapshot the outgoing page.
// Wrapping here avoids editing every `page.tsx` individually.
export default function Template({ children }: { children: React.ReactNode }) {
	const pathname = usePathname()
	return <SsgoiTransition id={pathname}>{children}</SsgoiTransition>
}
